module.exports = __webpack_public_path__ + "svg/flags/es-ct.svg";